import DateHandler from '@/shared/utils/date-format';

export default class ContractCanceledRuleHistory {
  rule: string;

  billingStrategy: string;

  billingValue: string;

  constructor(obj: any = {}) {
    this.rule = obj.rule || '';
    this.billingStrategy = obj.billingStrategy || '';
    this.billingValue = obj.billingValue || '';
  }

  public static of(obj: any = {}): ContractCanceledRuleHistory {
    return new ContractCanceledRuleHistory(obj);
  }

  public static ofList(obj: any[]): ContractCanceledRuleHistory[] {
    return obj.map(this.of)
  }

  get isDataFormat(): boolean {
    return this.billingStrategy === 'Data';
  }

  get billingValueText() {
    return this.isDataFormat
      ? DateHandler.timestampToLocal(this.billingValue)
      : `${this.billingValue}%`
  }
}
